import React, { useState, useEffect } from 'react';
import webRepositoriesData from './licenses/web.json';
import iosRepositoriesData from './licenses/ios.json';
import {
	Container,
	Section,
	Title,
	List,
	ListItem,
	Arrow,
	BackButton,
	RepoLink,
	LicenseText,
	LicenseSection,
	SelectContainer,
	PlatformTabs,
	PlatformTab,
} from './styles';

const OpenSourceLibraries = () => {
	const [selectedRepo, setSelectedRepo] = useState(null);
	const [platform, setPlatform] = useState('web');

	// Determine which data to use based on the platform state
	const repositoriesData =
		platform === 'web' ? webRepositoriesData : iosRepositoriesData;

	const showLicense = repoName => {
		const repo = repositoriesData.find(r => r.name === repoName);
		setSelectedRepo(repo);
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
		window.history.pushState('showLicense', '');
	};

	const onBackPressed = () => {
		window.history.back();
	};

	useEffect(() => {
		const handlePopState = () => {
			setSelectedRepo(null);
		};
		window.addEventListener('popstate', handlePopState);
		return () => window.removeEventListener('popstate', handlePopState);
	}, []);

	return (
		<Container>
			{!selectedRepo && (
				<SelectContainer>
					<PlatformTabs>
						<PlatformTab
							isActive={platform === 'web'}
							onClick={() => setPlatform('web')}
						>
							Web
						</PlatformTab>
						<PlatformTab
							isActive={platform === 'ios'}
							onClick={() => setPlatform('ios')}
						>
							iOS
						</PlatformTab>
					</PlatformTabs>
				</SelectContainer>
			)}
			{!selectedRepo ? (
				<Section>
					<Title>Open Source Libraries</Title>
					<List>
						{repositoriesData.map((repo, index) => (
							<ListItem
								key={`${repo.name}-${index}`}
								onClick={() => showLicense(repo.name)}
							>
								<span>{repo.name}</span>
								<Arrow>➔</Arrow>
							</ListItem>
						))}
					</List>
				</Section>
			) : (
				<LicenseSection>
					<BackButton onClick={onBackPressed}>← Back</BackButton>
					{selectedRepo.url && (
						<RepoLink href={selectedRepo.url}>{selectedRepo.name}</RepoLink>
					)}
					<LicenseText>{selectedRepo.license}</LicenseText>
				</LicenseSection>
			)}
		</Container>
	);
};

export default OpenSourceLibraries;
